import { Button, Grid, ListItem } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import CurrencyDisplay from '../common/CurrencyDisplay';
import DisplayMenu from '../common/DisplayMenu';
import DisplaySetMenu from '../common/DisplaySetMenu';
import DisplayTopping from '../common/DisplayTopping';

@inject('commonStore', 'cartStore', 'menuStore')
@observer
class MenuItem extends Component {
  modal;
  constructor(props) {
    super(props);
    this.state = {};
  }

  get menuTotalAmountInfo() {
    const { cartMenu, menuStore } = this.props;
    return menuStore.getTotalMenuAmount(cartMenu, cartMenu.qty);
  }

  handleClickUseCoupon = () => {
    const { cartMenu, cartStore } = this.props;
    cartStore.setCouponDialog(true, cartMenu);
  };

  handleClickDeleteCoupon = () => {
    const { t, commonStore, cartMenu, cartStore } = this.props;
    commonStore.openConfirmDialog(t('coupon.message.remove'), () => {
      cartStore.deleteCouponToCartMenu(cartMenu.uuid);
    });
  };

  handle;

  render() {
    const { t, cartMenu, menuStore } = this.props;
    return (
      <ListItem className="menu-detail">
        {/* 메뉴 */}
        <Grid container>
          <DisplayMenu
            name={cartMenu.name}
            qty={cartMenu.qty}
            amount={menuStore.getMenuAmountInfo(cartMenu, cartMenu.qty).totalAmount}
          />

          {/* 토핑 */}
          {cartMenu.toppingGroups && cartMenu.toppingGroups.length > 0 && (
            <DisplayTopping toppingGroups={cartMenu.toppingGroups} />
          )}

          {/* 세트 메뉴 */}
          {cartMenu.setMenuGroups && cartMenu.setMenuGroups.length > 0 && (
            <DisplaySetMenu setMenuGroups={cartMenu.setMenuGroups} />
          )}

          {/* 할인 */}
          {this.menuTotalAmountInfo.discountAmount > 0 && (
            <Grid item container direction="column">
              <Grid item container gap={1} direction="row">
                <Grid item xs style={{ alignItems: 'center', color: 'red', fontSize: '12px' }}>
                  {this.menuTotalAmountInfo.discountName}asdf
                </Grid>
                <Grid item style={{ width: '100px', fontSize: '12px', textAlign: 'right', color: 'red' }}>
                  (
                  <CurrencyDisplay
                    amount={this.menuTotalAmountInfo.discountAmount || 220}
                    size="small"
                    fontWeight="normal"
                    minus
                  />
                  )
                </Grid>
              </Grid>
            </Grid>
          )}

          {menuStore.storeData.isCouponUsed && (
            <Grid item container direction="row" gap={1} mt={1} justifyContent="flex-end">
              {cartMenu.couponData && (
                <Grid item>
                  <Button
                    variant="outlined"
                    size="small"
                    color="error"
                    disabled={this.menuTotalAmountInfo.discountAmount === 0}
                    onClick={this.handleClickDeleteCoupon}
                  >
                    {t('coupon.button.remove')}
                  </Button>
                </Grid>
              )}
              {this.menuTotalAmountInfo.discountAmount === 0 && (
                <Grid item>
                  <Button variant="outlined" size="small" onClick={this.handleClickUseCoupon}>
                    {t('coupon.button.use')}
                  </Button>
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
      </ListItem>
    );
  }
}

export default withRouter(withTranslation()(MenuItem));
